export default __webpack_public_path__ + "images/fkw_9d7c8f.png";